import { render } from "./SectionWelcomeBottom.vue?vue&type=template&id=1f7eba0e&scoped=true"
import script from "./SectionWelcomeBottom.vue?vue&type=script&lang=js"
export * from "./SectionWelcomeBottom.vue?vue&type=script&lang=js"

import "./SectionWelcomeBottom.vue?vue&type=style&index=0&id=1f7eba0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f7eba0e"]])

export default __exports__